export class SiteConfig {
    public static readonly BASE_URL = "";
    public static readonly GOOGLE_MAPS_API_KEY = "AIzaSyC6CIfuwZztPRf8LtcLSJO9WquozG-EMcg"; // the-road-south
    //public static readonly BASE_URL = "http://localhost:8080";
    //public static readonly GOOGLE_MAPS_API_KEY = "AIzaSyD9FQXHaEasn1dnAPiIP3rLVX3Da6wIm_c"; // local ip
}
